import { render, staticRenderFns } from "./AddPosturaEggs.vue?vue&type=template&id=75321ab6"
import script from "./AddPosturaEggs.vue?vue&type=script&lang=js"
export * from "./AddPosturaEggs.vue?vue&type=script&lang=js"
import style0 from "./AddPosturaEggs.vue?vue&type=style&index=0&id=75321ab6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports